import "./index.css";

import * as serviceWorker from "./serviceWorker";

import App from "./App";
import { BrowserRouter } from "react-router-dom";
import ContentfulContext from "./ContentfulContext.jsx";
import React from "react";
import ReactDOM from "react-dom";
import ScrollToTop from "./components/ScrollToTop.jsx";
import { createClient } from "contentful";

const client = createClient({
  space: "baism454se3a",
  accessToken: "SPVgz4guzKt8uUiHBrnH8By_16WFwdzwY1yWxUrepQk",
});

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <ContentfulContext.Provider value={client}>
        <App />
      </ContentfulContext.Provider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
